import { Site } from '@envato/foundation-types'

const data: any = {
  default: {
    elementsPromoTitle: 'Unlimited downloads',
    marketPromoTitle: 'Buy individual items',
    marketPromoButtonLabel: 'Continue browsing items',
    elementsPromoList: [
      'The ultimate all-in-one creative subscription',
      'Download video templates, stock footage, audio & more',
      'Subscribe from $16.50/m. Cancel any time'
    ],
    marketPromoList: [
      'High-quality items',
      'Unique and niche assets to suit your project',
      'Purchase individual items as you need them'
    ]
  },
  [Site.videohive]: {
    elementsPromoTitle: 'Unlimited video downloads',
    marketPromoTitle: 'Buy individual videos',
    marketPromoButtonLabel: 'Continue browsing videos',
    elementsPromoList: [
      'The unlimited all-in-one creative subscription',
      'Download video templates, stock footage, audio & more',
      'Subscribe from $16.50/m. Cancel any time'
    ],
    marketPromoList: [
      'High-quality video effects & templates',
      'Unique and niche stock footage to suit your project',
      'Purchase individual items as you need them'
    ]
  },
  [Site.themeforest]: {
    elementsPromoTitle: 'Unlimited theme downloads',
    marketPromoTitle: 'Buy individual themes',
    marketPromoButtonLabel: 'Continue browsing themes',
    elementsPromoList: [
      'The unlimited all-in-one creative subscription',
      'Download web templates, plugins, videos & more',
      'Subscribe from $16.50/m. Cancel any time'
    ],
    marketPromoList: [
      'High-quality themes with ongoing support',
      'Unique and niche templates to suit your project',
      'Purchase individual items as you need them'
    ]
  },
  [Site.audiojungle]: {
    elementsPromoTitle: 'Unlimited audio downloads',
    marketPromoTitle: 'Buy individual tracks',
    marketPromoButtonLabel: 'Continue browsing audio',
    elementsPromoList: [
      'The unlimited all-in-one creative subscription',
      'Download music, sound effects, video & more',
      'Subscribe from $16.50/m. Cancel any time'
    ],
    marketPromoList: [
      'High-quality audio tracks & sound effects',
      'Unique and niche sounds to suit your project',
      'Purchase individual items as you need them'
    ]
  },
  [Site.codecanyon]: {
    elementsPromoTitle: 'Unlimited code downloads',
    marketPromoTitle: 'Buy individual scripts & plugins',
    marketPromoButtonLabel: 'Continue browsing code',
    elementsPromoList: [
      'The unlimited all-in-one creative subscription',
      'Download plugins, web templates, videos & more',
      'Subscribe from $16.50/m. Cancel any time'
    ],
    marketPromoList: [
      'High-quality scripts & plugins',
      'Unique and niche code to suit your project',
      'Purchase individual items as you need them'
    ]
  },
  [Site.graphicriver]: {
    elementsPromoTitle: 'Unlimited graphic downloads',
    marketPromoTitle: 'Buy individual graphics',
    marketPromoButtonLabel: 'Continue browsing graphics',
    elementsPromoList: [
      'The unlimited all-in-one creative subscription',
      'Download graphics, photos, web templates & more',
      'Subscribe from $16.50/m. Cancel any time'
    ],
    marketPromoList: [
      'High-quality graphics, fonts & logos',
      'Unique and niche graphics to suit your project',
      'Purchase individual items as you need them'
    ]
  },
  [Site.photodune]: {
    elementsPromoTitle: 'Unlimited photo downloads',
    marketPromoTitle: 'Buy individual photos',
    marketPromoButtonLabel: 'Continue browsing photos',
    elementsPromoList: [
      'The unlimited all-in-one creative subscription',
      'Download photos, videos, graphics & more',
      'Subscribe from $16.50/m. Cancel any time'
    ],
    marketPromoList: [
      'High-quality stock photos & images',
      'Unique and niche photos to suit your project',
      'Purchase individual items as you need them'
    ]
  }
}

export default data
